import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { first, map, tap } from 'rxjs/operators';

import { DevicesRouterStoreSelectors, RouterStoreStates } from '../../../../stores/router';

import { Observable } from 'rxjs';
import { DevicesOsUpdateStatusActions, DevicesOsUpdateStatusStates } from './index';

@Injectable()
export class DeviceOsUpdateStatusResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly osUpdatesStore: Store<DevicesOsUpdateStatusStates.DeviceOsUpdateStatusState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.osUpdatesStore.dispatch(
          DevicesOsUpdateStatusActions.DeviceOsUpdateStatesResolverActions.osUpdateStateRequested({
            udid,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
